import React from 'react';
import { Table, Spin } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

interface BranchData {
  key: string;
  date: string;
  totalAmount: number;
  totalOrders: number;
  branchId?: string;
}

interface DateItemProps {
  data?: BranchData[];
  loading?: boolean;
}

const DateItem: React.FC<DateItemProps> = ({ data = [], loading = false }) => {
  const columns: ColumnsType<BranchData> = [
    {
      title: 'Month',
      dataIndex: 'date',
      key: 'date',
      render: (text) => dayjs(text).format('MMMM YYYY'),
      sorter: (a, b) => dayjs(a.date).valueOf() - dayjs(b.date).valueOf(),
      defaultSortOrder: 'ascend',
      width: '200px',
    },
    {
      title: 'Total Amount',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      render: (value) => {
        const numericValue = parseFloat(value as any);
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(isNaN(numericValue) ? 0 : numericValue);
      },
      sorter: (a, b) => a.totalAmount - b.totalAmount,
      width: '200px',
    },
    {
      title: 'Total Orders',
      dataIndex: 'totalOrders',
      key: 'totalOrders',
      render: (value) => value.toLocaleString(),
      sorter: (a, b) => a.totalOrders - b.totalOrders,
      width: '150px',
    },
  ];

  return (
    <div className="report-table">
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={data}
          pagination={{ pageSize: 12 }}
          scroll={{ x: true }}
          rowClassName={() => 'report-table-row'}
          className="monthly-report-table"
        />
      </Spin>
    </div>
  );
};

export default DateItem;
